<template>
  <v-sheet tile class="fill-height loading-overlay" color="primary" align="center">
    <v-container fluid class="fill-height">
      <v-card-text>
        <br/>
        <v-img src="/static/logo.png" class="main-logo"></v-img>
        <br/>
        <v-progress-circular color="white" indeterminate></v-progress-circular>
        <br/>
        <br/>
        <v-sheet tile color="primary" dark>Loading...</v-sheet>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      </v-card-text>
    </v-container>
  </v-sheet>
</template>


<script>
  import {mapGetters} from "vuex";

  export default {
    name: "SigningPage",
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/Pages/SigningPage.vue